module.exports = __webpack_public_path__ + "media/img/pages/companies/groupe-mutuel-112a49b542cfc779ac85bde7281ee6b8.webp";